<script lang="ts">
import { defineComponent as __MACROS_defineComponent } from "vue";
export default /*#__PURE__*/ __MACROS_defineComponent({
  name: 'Histoire'
});
</script>
<template>
  <ka-container
    code="notre-histoire"
    :data="page.$info.notreHistoire">
    <!-- Header -->
    <ka-container code="header">
      <!-- Haut de Page 3 -->
      <ka-container
        code="haut-de-page-3"
        inner>
        <!-- Partie A -->
        <ka-container code="partie-a">
          <ka-image
            code="logo-de-lentreprise"
            :options="{
              animationIn: `fadeIn`,
              href: { path: `/` },
              ariaLabel: `home`,
              lazyOptions: {
                throttle: 200,
                once: true,
                intersection: { threshold: 0.1 }
              },
              click: page.logoDeLentrepriseClick,
              alt: `Logo de l'entreprise`
            }"
            value="https://ucarecdn.com/f1c410a0-cc37-4bfd-b333-509dcc21b41f/" />
          <ka-separator
            code="separator"
            :xs="{ hidden: null }" />
          <HeaderOnglet
            instance-class="header-onglet--p139"
            :options="{ click: page.headerOngletClick }"
            :xs="{ hidden: null }"
            titre-onglet="Entreprise" />
          <HeaderOnglet
            instance-class="element-1--p139"
            :options="{ click: page.element1Click }"
            :xs="{ hidden: null }"
            titre-onglet="Expert" />
          <HeaderOnglet
            instance-class="element-2--p139"
            :options="{ click: page.element2Click }"
            :xs="{ hidden: null }"
            titre-onglet="Formations" />
          <ka-text
            code="onglet-a-propos"
            :options="{
              href: { name: `Infos` },
              click: page.ongletAProposClick,
              textNoWrap: true
            }"
            :xs="{ hidden: null }">
            <span v-html="t('notreHistoire.header.hautDePage3.partieA.ongletAPropos.value', `À propos`)" />
          </ka-text>
        </ka-container>
        <!-- Partie B -->
        <ka-container
          code="partie-b"
          :xs="{ hidden: true }">
          <ka-button
            code="contact"
            :options="{
              ripple: true,
              href: { name: `Contact` },
              click: page.contactClick
            }">
            <span v-html="t('notreHistoire.header.hautDePage3.partieB.contact.value', `Contact`)" />
          </ka-button>
          <!-- Container-btn-contact -->
          <ka-container code="container-btn-contact">
            <HeaderBtnSonProfilOuConnexion instance-class="header-btn-son-profil-ou-connexion--p139" />
          </ka-container>
        </ka-container>
        <!-- Menu Burger -->
        <ka-container
          code="menu-burger"
          :options="{ hidden: true }"
          :xs="{
            click: page.menuBurgerClickOnXs,
            hidden: false
          }"
          :xs-selected="{ click: page.menuBurgerClickOnXsWhenSelected }">
          <ka-icon
            code="icone"
            :options="{
              hidden: true,
              $inheritState: { selected: true }
            }"
            :xs="{ hidden: false }"
            value="i-fa-solid:icons"
            xs-value="i-fa-solid:align-justify" />
        </ka-container>
      </ka-container>
    </ka-container>
    <!-- Container page -->
    <ka-container code="container-page">
      <!-- Container -->
      <ka-container code="container">
        <!-- Photo -->
        <ka-container code="photo">
          <!-- Fond bleu -->
          <ka-container code="fond-bleu">
            <!-- Texte -->
            <ka-container code="texte">
              <ka-text code="en-octobre-2023-matchers">
                <h1 v-html="t('notreHistoire.containerPage.container.photo.fondBleu.texte.enOctobre2023Matchers.value', `En octobre 2023, Matchers lève 2 millions d’euros, retour sur l'idée née, il y a 4 ans `)" />
              </ka-text>
              <ka-text code="alors-que-la-formation">
                <span v-html="t('notreHistoire.containerPage.container.photo.fondBleu.texte.alorsQueLaFormation.value', `Alors que la formation permet à une entreprise de gagner en compétence et en productivité, 71% des TPE ne forment ni leurs dirigeants, ni leurs salariés. Matchers lève 2 millions d’euros pour démocratiser la mise en place de formations dans les petites boîtes.`)" />
              </ka-text>
            </ka-container>
          </ka-container>
        </ka-container>
      </ka-container>
      <!-- Bande avec infos mobile -->
      <ka-container code="bande-avec-infos-mobile">
        <ka-text code="voir-aussi">
          <span v-html="t('notreHistoire.containerPage.bandeAvecInfosMobile.voirAussi.value', `Voir aussi : `)" />
        </ka-text>
        <ka-text
          code="le-communique-de-presse"
          :options="{
            href: `https://drive.google.com/file/d/1ozlrZiibXOmMvBqFlbxPf5xIr7Wa957w/view?usp=drive_link`,
            ariaLabel: `text 9`,
            click: page.leCommuniqueDePresseClick
          }">
          <span v-html="t('notreHistoire.containerPage.bandeAvecInfosMobile.leCommuniqueDePresse.value', `<ul><li>Le communiqué de presse de la levée de fonds</li></ul>`)" />
        </ka-text>
        <ka-text
          code="le-kit-de-communication"
          :options="{
            href: `https://drive.google.com/drive/folders/1ELGsUtJjpatC_GXuYjMNUa8TssSImu-5?usp=drive_link`,
            ariaLabel: `text 9`,
            click: page.leKitDeCommunicationClick
          }">
          <span v-html="t('notreHistoire.containerPage.bandeAvecInfosMobile.leKitDeCommunication.value', `<ul><li>Le kit de communication </li></ul>`)" />
        </ka-text>
        <ka-text
          code="presentation-des-co-fondateurs"
          :options="{
            href: `https://docs.google.com/presentation/d/1rSy8wnFrlVdW4oQD1EDq7fqpHEZAm5ip-uh8C9MLysA/edit?usp=sharing`,
            ariaLabel: `text 9`,
            click: page.presentationDesCoFondateursClick
          }">
          <span v-html="t('notreHistoire.containerPage.bandeAvecInfosMobile.presentationDesCoFondateurs.value', `<ul><li>Présentation des co-fondateurs et de l'équipe</li></ul>`)" />
        </ka-text>
        <ka-text code="contact-presse">
          <span v-html="t('notreHistoire.containerPage.bandeAvecInfosMobile.contactPresse.value', `Contact presse : `)" />
        </ka-text>
        <ka-image
          code="image-1"
          :options="{
            animationIn: `fadeIn`,
            lazyOptions: {
              throttle: 200,
              once: true,
              intersection: { threshold: 0.1 }
            },
            imgFit: `cover`,
            alt: `Image 1`
          }"
          value="https://ucarecdn.com/ff465ceb-8d44-40fb-bee8-a26e65ad5f72/" />
        <ka-text code="claire-bachini-responsable">
          <span v-html="t('notreHistoire.containerPage.bandeAvecInfosMobile.claireBachiniResponsable.value', `Claire Bachini <br>Responsable communication <br>claire&#64;matchers.fr<br>06.98.19.22.62`)" />
        </ka-text>
        <!-- bouton -->
        <ka-container
          code="bouton"
          :options="{
            href: `https://meetings.hubspot.com/claire-bachini`,
            ariaLabel: `bouton`,
            click: page.boutonClick
          }">
          <ka-text code="prendre-rendez-vous">
            <span v-html="t('notreHistoire.containerPage.bandeAvecInfosMobile.bouton.prendreRendezVous.value', `Prendre rendez-vous`)" />
          </ka-text>
        </ka-container>
      </ka-container>
      <!-- Bande avec infos -->
      <ka-container
        code="bande-avec-infos"
        :options="{ hidden: true }"
        :xs="{ hidden: null }">
        <ka-text code="text-1">
          <span v-html="t('notreHistoire.containerPage.bandeAvecInfos.text1.value', `Voir aussi : `)" />
        </ka-text>
        <ka-text code="text-2">
          <span v-html="t('notreHistoire.containerPage.bandeAvecInfos.text2.value', `<ul><li>Le communiqué de presse de la levée de fonds</li></ul>`)" />
        </ka-text>
        <ka-text code="text-3">
          <span v-html="t('notreHistoire.containerPage.bandeAvecInfos.text3.value', `<ul><li>Le kit de communication </li></ul>`)" />
        </ka-text>
        <ka-text code="text-4">
          <span v-html="t('notreHistoire.containerPage.bandeAvecInfos.text4.value', `<ul><li>Présentation des co-fondateurs et de l'équipe</li></ul>`)" />
        </ka-text>
        <ka-text code="text-5">
          <span v-html="t('notreHistoire.containerPage.bandeAvecInfos.text5.value', `Contact presse : `)" />
        </ka-text>
        <ka-image
          code="image-2"
          :options="{
            animationIn: `fadeIn`,
            lazyOptions: {
              throttle: 200,
              once: true,
              intersection: { threshold: 0.1 }
            },
            imgFit: `cover`,
            alt: `Image 1`
          }"
          value="https://ucarecdn.com/ff465ceb-8d44-40fb-bee8-a26e65ad5f72/" />
        <ka-text code="text-6">
          <span v-html="t('notreHistoire.containerPage.bandeAvecInfos.text6.value', `Claire Bachini <br>Responsable communication <br>claire&#64;matchers.fr<br>06.98.19.22.62`)" />
        </ka-text>
      </ka-container>
      <!-- Texte -->
      <ka-container code="container-1">
        <ka-text code="autour-de-moi">
          <span v-html="t('notreHistoire.containerPage.container1.autourDeMoi.value', `<span style='background-color:transparent;color:#000000;'>“</span><span style='color:#1100A2FF;'>Autour de moi, plusieurs personnes avaient monté leur entreprise et après des années de salariat j’étais devenu leur contact numéro 1 pour obtenir des conseils sur mes sujets d’expertise</span><span style='background-color:transparent;color:#000000;'>” </span>`)" />
        </ka-text>
        <ka-text code="affirme-jean-marie">
          <span v-html="t('notreHistoire.containerPage.container1.affirmeJeanMarie.value', `<span style='background-color:transparent;color:#1100A2FF;'>affirme Jean-Marie Dupré, ancien DRH et co-fondateur de Matchers.</span>`)" />
        </ka-text>
        <ka-text code="etonne-par-le-nombre">
          <span v-html="t('notreHistoire.containerPage.container1.etonneParLeNombre.value', `<span style='background-color:transparent;color:#000000;'>Étonné par le nombre de contacts qui préfèrent lui téléphoner plutôt que d’engager un prestataire, il se pose des questions. Pourquoi moi ? Pourquoi ne pas passer par une personne dont c’est le métier ? Les réponses sont unanimes : “trouver LA bonne personne, qui puisse vraiment m’aider sur ma problématique me prendrait trop de temps et me coûterait trop cher”. </span><br> <br><span style='background-color:transparent;color:#000000;'>Arrive alors le start-up week-end Montpelliérain. Jean-Marie s'inscrit presque par hasard pour pitcher cette idée : créer la rencontre entre les petites boîtes qui manquent de compétences et les salariés expérimentés qui sous-exploitent leurs connaissances en ne les dédiant qu’à une seule entreprise. Stéphane, convaincu depuis toujours par l'entrepreneuriat mais tout juste décidé à se lancer, rejoint son groupe de travail. </span><br> <br>🔥   <span style='background-color:transparent;color:#000000;'>48 heures plus tard, ils terminent lauréats du week-end.  </span>🔥`)" />
        </ka-text>
        <ka-image
          code="image-3"
          :options="{
            animationIn: `fadeIn`,
            lazyOptions: {
              throttle: 200,
              once: true,
              intersection: { threshold: 0.1 }
            },
            alt: `Image`
          }"
          value="https://ucarecdn.com/dc30ac53-116f-40cb-a366-0aebaa17a58e/-/crop/4272x2337/0,232/-/preview/" />
        <ka-text code="bien-decides-a-permetre">
          <span v-html="t('notreHistoire.containerPage.container1.bienDecidesAPermetre.value', `Bien décidés à permetre aux salariés expérimentés de partager leurs compétences aux petites entreprises ils testent plusieurs formats. Tous suscitaient de l'intérêt mais aucun un réel engagement. `)" />
        </ka-text>
        <ka-text code="le-covid-veritable">
          <h2 v-html="t('notreHistoire.containerPage.container1.leCovidVeritable.value', `<span style='background-color:transparent;'><strong>Le covid, véritable tremplin pour trouver leur modèle : la formation</strong></span>`)" />
        </ka-text>
        <ka-text code="la-periode-covid">
          <span v-html="t('notreHistoire.containerPage.container1.laPeriodeCovid.value', `<span style='color:#1100A2FF;'>“La période covid a été déterminante pour l’entreprise”. </span>`)" />
        </ka-text>
        <ka-text code="mars-2020-matchers">
          <span v-html="t('notreHistoire.containerPage.container1.mars2020Matchers.value', page.$constants.mars2020Matchers)" />
        </ka-text>
        <ka-text code="une-cinquantaine">
          <span v-html="t('notreHistoire.containerPage.container1.uneCinquantaine.value', `<span style='color:#1100A2FF;'>“Une cinquantaine d’entreprises accompagnées plus tard, notre product-market fit apparaissait comme une évidence”.</span>`)" />
        </ka-text>
        <ka-text code="alors-que-matchers">
          <span v-html="t('notreHistoire.containerPage.container1.alorsQueMatchers.value', `Alors que Matchers agissait jusqu'à présent sous le format de conseil, cette période de transformation et d'activité partielle a permis de mettre en lumière un besoin dans les petites entreprises, celui de former leurs équipes. <br> <br>Effectivement, pour la cinquantaine d'entreprises accompagnées durant la crise, leurs experts ont enfilé une nouvelle casquette, celle de formateur. Durant cette période, la formation est venue donner les armes nécessaires aux équipes des petites entreprises pour repartir. Le format de visioconférence que proposait Matchers s’est également totalement démocratisé. Pendant 1 an, le service Matchers était entièrement démonétisé et ça marchait ! Les fondateurs réalisent alors une chose : pour démocratiser la formation sur-mesure, il faut la rendre plus accessible financièrement. Déterminés à accompagner le plus de petites entreprises possible, ils se sont spécialisés dans les financements dédiés aux start-up, TPE et PME en matière de formation professionnelle. `)" />
        </ka-text>
        <ka-text code="plus-que-de-la-formation">
          <h2 v-html="t('notreHistoire.containerPage.container1.plusQueDeLaFormation.value', `<strong>Plus que de la formation sur-mesure, Matchers propose une formule magique, sans coût administratif ni financier</strong>`)" />
        </ka-text>
        <ka-text code="post-covid-la-proposition">
          <span v-html="t('notreHistoire.containerPage.container1.postCovidLaProposition.value', `Post-covid, la proposition était claire : <strong>proposer des formations-action séquencées 100% finançables aux côtés d’experts métier </strong>qui s’adaptent aux contraintes des entreprises. Une problématique demeurait : la charge administrative pour obtenir les financements.<br> <br>L’équipe Matchers l’a immédiatement compris : dans les petites boîtes, personne n’est vraiment là pour faire de la paperasse. Ni une, ni deux, ils se mettent à le faire pour le compte du client. Identification du financement, matching avec l’expert idéal, déblocage des fonds et suivi de la formation. <br> <br>Mais alors la suite, c’est quoi ? 🤔`)" />
        </ka-text>
        <ka-image
          code="image-4"
          :options="{
            animationIn: `fadeIn`,
            lazyOptions: {
              throttle: 200,
              once: true,
              intersection: { threshold: 0.1 }
            },
            alt: `Image 2`
          }"
          value="https://ucarecdn.com/9b78dcc2-6ec1-435d-9e4f-d1d9ed777685/" />
        <ka-text code="automatiser-et-digitaliser">
          <h2 v-html="t('notreHistoire.containerPage.container1.automatiserEtDigitaliser.value', `<strong>Automatiser et digitaliser pour scaler : la mise en place de formations sur-mesure dans les petites entreprises doit se faire en quelques clics</strong>`)" />
        </ka-text>
        <ka-text code="avec-matchers-du-debut">
          <span v-html="t('notreHistoire.containerPage.container1.avecMatchersDuDebut.value', `Avec Matchers, du début jusqu’à la fin, tout est pensé <strong>sur-mesure</strong>. Cette personnalisation permanente a un coût : de nombreuses heures de travail pour adapter chaque étape à chaque entreprise. Dopés par les retours dithyrambiques des entreprises qu’ils accompagnent, ils veulent faire de Matchers LA référence en matière de formation sur-mesure d’ici 3 ans. <br> <br>Matchers lance aujourd’hui le développement de son produit pour permettre une gestion plus rapide et fluide de toutes les étapes en interne comme en externe pour mettre en place des formations sur-mesure. Matchers projette une communauté de plus de 1200 experts et 650 entreprises accompagnées D'ICI UN AN ! `)" />
        </ka-text>
        <ka-text code="la-levee-ce-nest">
          <span v-html="t('notreHistoire.containerPage.container1.laLeveeCeNest.value', `<span style='color:#1100A2FF;'>“La levée ce n'est qu'une étape, </span><br><span style='color:#1100A2FF;'>2024, on arrrrrivvvvveeeeee”.</span>`)" />
          <template #xs>
            <span v-html="t('notreHistoire.containerPage.container1.laLeveeCeNest.xs.value', `<blockquote><p><span style='color:#1100A2FF;'>“La levée ce n'est qu'une étape, 2024, on arrrrrivvvvveeeeee”.</span></p></blockquote>`)" />
          </template>
        </ka-text>
        <ka-text code="la-team-matchers">
          <span v-html="t('notreHistoire.containerPage.container1.laTeamMatchers.value', `La team Matchers 💪`)" />
        </ka-text>
      </ka-container>
    </ka-container>
    <!-- Footer -->
    <ka-container code="footer">
      <!-- Footer -->
      <ka-container code="container-2">
        <!-- Logo -->
        <ka-container code="logo">
          <ka-image
            code="image-5"
            :options="{
              animationIn: null,
              lazyOptions: {
                throttle: 200,
                once: true,
                intersection: { threshold: 0.1 }
              },
              imgFit: `cover`,
              alt: `Image`
            }"
            value="https://ucarecdn.com/e10a1429-f4f5-4570-84fa-a16fa6155d1f/" />
        </ka-container>
        <!-- CGU col -->
        <ka-container code="cgu-col">
          <ka-text code="informations-legales">
            <span v-html="t('notreHistoire.footer.container2.cguCol.informationsLegales.value', `Informations légales`)" />
          </ka-text>
          <ka-text
            code="donnees-personnelles"
            :options="{
              href: { name: `donnees-personnelles` },
              click: page.donneesPersonnellesClick
            }">
            <span v-html="t('notreHistoire.footer.container2.cguCol.donneesPersonnelles.value', `Données personnelles`)" />
          </ka-text>
          <ka-text
            code="conditions-generales"
            :options="{
              href: { name: `Cgv` },
              click: page.conditionsGeneralesClick
            }">
            <span v-html="t('notreHistoire.footer.container2.cguCol.conditionsGenerales.value', `Conditions générales`)" />
          </ka-text>
          <ka-text
            code="mentions-legales"
            :options="{
              href: { name: `mentions-legales` },
              click: page.mentionsLegalesClick
            }">
            <span v-html="t('notreHistoire.footer.container2.cguCol.mentionsLegales.value', `Mentions légales`)" />
          </ka-text>
          <ka-text code="version-du-site">
            <span v-html="t('notreHistoire.footer.container2.cguCol.versionDuSite.value', `Version du site - {0}`, [page.$data.version])" />
          </ka-text>
        </ka-container>
        <!-- Contacte col -->
        <ka-container code="contacte-col">
          <ka-text code="contactez-nous">
            <span v-html="t('notreHistoire.footer.container2.contacteCol.contactezNous.value', `Contactez-nous`)" />
          </ka-text>
          <!-- Telephone -->
          <ka-container code="telephone">
            <ka-icon
              code="icon"
              value="i-fa-solid:phone fa-rotate-90" />
            <ka-text code="k-0972264399">
              <span v-html="t('notreHistoire.footer.container2.contacteCol.telephone.k0972264399.value', `09 72 26 43 99`)" />
            </ka-text>
          </ka-container>
          <!-- mail -->
          <ka-container code="mail">
            <ka-icon
              code="icon-1"
              value="i-fa-regular:envelope" />
            <ka-text code="contact-matchers-fr">
              <span v-html="t('notreHistoire.footer.container2.contacteCol.mail.contactMatchersFr.value', `contact&#64;matchers.fr`)" />
            </ka-text>
          </ka-container>
          <!-- linkedin facebook -->
          <ka-container code="linkedin-facebook">
            <ka-icon
              code="icon-2"
              :options="{
                href: `https://www.linkedin.com/company/linkedin-com-company-matchers/`,
                ariaLabel: `icon`,
                click: page.icon2Click
              }"
              value="i-fa-brands:linkedin-in" />
            <ka-icon
              code="icon-3"
              :options="{
                href: `https://www.facebook.com/matchersfr`,
                ariaLabel: `icon`,
                click: page.icon3Click
              }"
              value="i-fa-brands:facebook-f" />
          </ka-container>
        </ka-container>
        <!-- News letter -->
        <ka-container code="news-letter">
          <!-- News letter -->
          <ka-container code="container-3">
            <ka-text code="inscrivez-vous-a-notre">
              <span v-html="t('notreHistoire.footer.container2.newsLetter.container3.inscrivezVousANotre.value', `Inscrivez-vous à notre newsletter`)" />
            </ka-text>
            <ka-text code="que-des-infos-utiles">
              <span v-html="t('notreHistoire.footer.container2.newsLetter.container3.queDesInfosUtiles.value', `Que des infos utiles et pas d’abus, c’est promis !`)" />
            </ka-text>
            <!-- Container -->
            <ka-container code="container-4">
              <ka-string-input
                v-model="page.saisieDeTexte.value"
                code="saisie-de-texte"
                :options="{ placeholder: t('notreHistoire.footer.container2.newsLetter.container3.container4.saisieDeTexte.placeholder', `Votre email`) }" />
              <ka-button
                code="soumettre"
                :options="{
                  ripple: true,
                  click: page.soumettreClick
                }">
                <span v-html="t('notreHistoire.footer.container2.newsLetter.container3.container4.soumettre.value', `Soumettre`)" />
              </ka-button>
            </ka-container>
          </ka-container>
        </ka-container>
      </ka-container>
    </ka-container>
  </ka-container>
</template>

<script setup lang="ts">
import { generateMeta, syncPageStore } from 'kapix-components-vue3'
import { histoire } from './store'
import HeaderBtnSonProfilOuConnexion from '~/components/HeaderBtnSonProfilOuConnexion/index.vue'
import HeaderOnglet from '~/components/HeaderOnglet/index.vue'
import { appDataStore } from '~/stores'
import './style.scss'
import './style.custom.scss'


provide('$scoped', '--p139')
const appData = appDataStore()
const page = histoire()
const props = withDefaults(defineProps<{
  seo?: Nullable<boolean>
}>(), {
  seo: true
})

syncPageStore(page)
// SEO
if (props.seo) {
  // https://github.com/vueuse/head
  useHead({
    title: computed(() => page.$title),
    htmlAttrs: { lang: appData.locale },
    meta: computed(() => generateMeta({
      title: page.$title,
      description: page.$description,
      canonicalUrl: appData.hostname,
      publishedTime: page.$publishedTime,
      modifiedTime: page.$modifiedTime,
      ...appData.twitter
    }))
  })

  useSchemaOrg([
    // https://vue-schema-org.netlify.app/api/schema/webpage.html#type-definition
    defineWebPage({
      name: page.$title,
      description: page.$description,
      inLanguage: appData.locale,
      primaryImageOfPage: appData.twitter.image,
      datePublished: page.$publishedTime
      // dateModified: page.$modifiedTime?.toISOString()
    })
  ])
}
</script>
